<template>
    <div>
        <section
            class="itb-hero-image text-center"
            style="padding-top: 1.8rem"
            v-lazy-container="{ selector: '.itb-lazy' }"
        >
            <img
                v-if="playground.imageHero"
                :data-src="
                    '/uploads/' +
                        playground.imageHero.path +
                        '/' +
                        playground.imageHero.name
                "
                :alt="playground.title"
                class="itb-lazy"
            />
            <h2 style="margin: 2.6rem 0px 1.1rem">{{ playground.title }}</h2>
            <p class="itb-h2-subtitle itb-orange" style="margin-bottom: 1.3rem">
                {{ playground.subtitle }}
            </p>
        </section>
        <section class="itb-references-alike-set">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-4">
                        <div class="row">
                            <div class="col-12">
                                <div
                                    class="card w-100 itb-with-border itb-margin-bottom itb-lazy-loading-bg open-tinybox"
                                    @click="index = 0"
                                    v-lazy:background-image="
                                        playground.detailImages
                                            ? playground.detailImages[0]
                                                  .thumbnail
                                            : null
                                    "
                                    style="height: 15.3rem"
                                >
                                    <div class="card-body d-flex p-0">
                                        <div
                                            class="itb-text align-self-end w-100"
                                        >
                                            <h3 class="mb-0">
                                                {{
                                                    $t(
                                                        "playgrounds.show_floor_plan"
                                                    )
                                                }}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <h3 class="text-left itb-color-blue">
                                    {{ $t("playgrounds.download") }}
                                </h3>
                                <div class="itb-download-list pt-0">
                                    <div
                                        class="card w-100"
                                        v-if="playground.downloadItem"
                                    >
                                        <div
                                            class="card-body d-flex align-items-center p-0"
                                            v-lazy-container="{
                                                selector: '.itb-lazy'
                                            }"
                                        >
                                            <img
                                                class="itb-lazy"
                                                v-if="
                                                    playground.downloadItem
                                                        .thumbnail
                                                "
                                                :data-src="
                                                    '/uploads/' +
                                                        playground.downloadItem
                                                            .thumbnail.path +
                                                        '/' +
                                                        playground.downloadItem
                                                            .thumbnail.name
                                                "
                                                :alt="
                                                    playground.downloadItem.name
                                                "
                                                style="max-width: 136px"
                                            />
                                            <div class="itb-content">
                                                <div>
                                                    <span>{{
                                                        playground.downloadItem
                                                            .name
                                                    }}</span>
                                                </div>
                                                <div>
                                                    <a
                                                        :href="
                                                            '/uploads/' +
                                                                playground
                                                                    .downloadItem
                                                                    .file.path +
                                                                '/' +
                                                                playground
                                                                    .downloadItem
                                                                    .file.name
                                                        "
                                                        class="ml-auto"
                                                        download
                                                        v-if="
                                                            playground
                                                                .downloadItem
                                                                .file
                                                        "
                                                    >
                                                        <span>{{
                                                            $t(
                                                                "downloads.download"
                                                            )
                                                        }}</span>
                                                        <img
                                                            src="/images/icons/4soft_icon_download_blue.svg"
                                                            :alt="
                                                                $t(
                                                                    'general.button'
                                                                ) +
                                                                    ' ' +
                                                                    $t(
                                                                        'downloads.download'
                                                                    )
                                                            "
                                                            class="itb-icon itb-download-icon"
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <h3 class="text-left itb-color-blue">
                                    {{ $t("playgrounds.gallery") }}
                                </h3>
                            </div>

                            <Tinybox
                                v-model="index"
                                :images="
                                    playground.detailImages
                                        ? playground.detailImages
                                        : []
                                "
                            ></Tinybox>
                            <div
                                class="col-12 col-md-6"
                                v-for="(image, idx) in playground.detailImages"
                                v-if="image.type == 'gallery'"
                                :key="idx"
                            >
                                <div
                                    class="card w-100 itb-margin-bottom itb-small-card itb-lazy-loading-bg open-tinybox"
                                    @click="index = idx"
                                    v-lazy:background-image="image.thumbnail"
                                    :title="image.caption"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-8">
                        <div class="itb-input-like-group itb-margin-bottom">
                            <div class="itb-label">
                                {{ $t("playgrounds.dimensions") }}
                            </div>
                            <div class="itb-text">
                                <span class="itb-font-black">{{
                                    playground.dimensions
                                }}</span>
                            </div>
                        </div>
                        <div class="itb-input-like-group itb-margin-bottom">
                            <div class="itb-label">
                                {{ $t("playgrounds.guarantee") }}
                            </div>
                            <div class="itb-text">
                                <span class="itb-font-black">{{
                                    playground.guarantee
                                }}</span>
                            </div>
                        </div>
                        <div
                            v-if="!isResponsive"
                            class="itb-input-like-group itb-big itb-margin-bottom"
                        >
                            <div class="itb-label">
                                {{ $t("playgrounds.budget") }}
                            </div>

                            <div
                                class="itb-text d-flex flex-column pl-0 pr-0"
                                style="padding-top:0.7rem; padding-bottom: 0.7rem;"
                            >
                                <span
                                    class="itb-font-black w-100"
                                    style="padding-left:1.8rem; padding-bottom: 0.7rem;"
                                >
                                    {{ playground.budget }}
                                </span>
                                <span
                                    class="itb-font-black w-100 border-top"
                                    style="padding-left:1.8rem; padding-top: 0.7rem;"
                                >
                                    {{ playground.budget_eur }}
                                </span>
                            </div>
                        </div>
                        <div
                            v-if="isResponsive"
                            class="itb-input-like-group itb-margin-bottom"
                        >
                            <div class="itb-label">
                                {{ $t("playgrounds.budget") }}
                            </div>
                            <div class="itb-text">
                                <span class="itb-font-black">{{
                                    playground.budget
                                }}</span>
                            </div>
                        </div>
                        <div
                            v-if="isResponsive"
                            class="itb-input-like-group itb-margin-bottom"
                        >
                            <div class="itb-label">
                                {{ $t("playgrounds.budget_eur") }}
                            </div>
                            <div class="itb-text">
                                <span class="itb-font-black">{{
                                    playground.budget_eur
                                }}</span>
                            </div>
                        </div>

                        <div
                            class="itb-input-like-group itb-big itb-margin-bottom"
                        >
                            <div class="itb-label">
                                {{ $t("playgrounds.description") }}
                            </div>
                            <div
                                class="itb-text"
                                style="white-space: pre-line"
                                v-html="playground.description"
                            ></div>
                        </div>

                        <button
                            class="btn btn-primary itb-btn-icon mt-0"
                            style="float: left"
                            @click="scrollToElement('itb-contact-form')"
                        >
                            {{ $t("playgrounds.i_like_it") }}
                            <img
                                src="/images/icons/4soft_icon_angle-right.svg"
                                :alt="
                                    $t('general.button') +
                                        ' ' +
                                        $t('playgrounds.i_like_it')
                                "
                                class="itb-icon itb-angle-right-icon"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Tinybox from "vue-tinybox";

export default {
    data() {
        return {
            index: null,
            pageParams: [],
            playground: [],
            isResponsive: false
        };
    },

    components: {
        Tinybox
    },

    mounted() {
        axios
            .get(
                `/getPlaygroundDetailPage/${
                    this.$route.params.playgroundAlias.split("-")[0]
                }`
            )
            .then(response => {
                this.pageParams = response.data.params;
                this.playground = response.data.playground;
                this.pageParams.achievementClass = "itb-smaller";
                this.setPageParams(this.pageParams);
            })
            .catch(error => {
                console.log(error);
            });

        this.onResize();

        window.addEventListener("resize", this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams"
        })
    },

    methods: {
        ...mapActions(["setPageParams"]),
        scrollToElement(elementId) {
            this.$parent.scrollToElement(elementId);
        },

        onResize() {
            if (window.innerWidth < 992) {
                this.isResponsive = true;
            } else {
                this.isResponsive = false;
            }
        }
    }
};
</script>
